import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import TrendGraphHighcharts from "../trend-graph-highcharts";
// import TrendGraphRecharts from './trend-graph-recharts';

import { allData as allDataFn } from "../trend-graph-utils";

import moment from "moment";

import { trendDurationVar } from "../../reactive-variables";

const TrendMetaData = loader("../../graphql/TrendMetaDataLiveData.graphql");

const TrendValues = loader("../../graphql/TrendValues.graphql");

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  panelName?: String;
  panelDefinition: any;
  startDate?: number; // Date;
  endDate?: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
  metaData?: any;
}

// FIXME This is mainly copy&paste of TrendGraphContainer

function TrendGraphContainer(props: Props) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    nodes,
    panelCollectionName,
    // panelId,
    panelName,
    panelDefinition,
    startDate,
    endDate,
    widgetStatic,
    widgetTitle,
    metaData: metaDataInput,
  } = props;

  // if (panelId) {
  //  // Fetch DataViewPanelState with sensors and thresholds and event nodes
  // } else {
  //  // Create new DataViewPanelState (see TrendURLHandler)
  //  // for the (selected) nodes get tags (see TrendURLHandler#getTags)
  //  //
  // }
  //// Generate flot/highcharts metadata and (in parallel)
  //// Fetch values and transform to highcharts data => use highcharts methods? use dynamic loading?
  const n = nodes ? nodes.join(",") : undefined;
  // console.log("currentTrendDuration", trendDurationVar());

  const { data, error: metaError, loading: metaLoading } = useQuery(
    TrendMetaData,
    {
      skip: metaDataInput !== undefined && metaDataInput !== null,
      variables: {
        panelCollectionName: panelCollectionName,
        panelName: panelName ? panelName : panelDefinition?.template,
        tab: panelDefinition?.id,
        node: n,
        trendDuration: trendDurationVar() || undefined, // TODO otherwise it is null if unset
      },
    }
  );
  // console.log("TrendMetaData", data, metaError, metaLoading);
  const metaData = metaDataInput ? metaDataInput : data?.metaData;
  const startFromMeta = metaData?.options?.xaxis?.min;
  const endFromMeta = metaData?.options?.xaxis?.max;
  const start =
    startDate || startFromMeta
      ? moment(parseInt(startDate || startFromMeta, 10)).unix()
      : undefined;
  const end =
    endDate || endFromMeta
      ? moment(parseInt(endDate || endFromMeta, 10)).unix()
      : undefined;
  const {
    data: dataSeries,
    error: valuesError,
    loading: valuesLoading,
  } = useQuery(TrendValues, {
    variables: {
      panelId: metaData?.options?.panelId,
      nodes: undefined /*n*/,
      startDate: start,
      endDate: end,
    },
  });
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  if (valuesLoading) {
    return <div>Loading...</div>;
  }
  if (valuesError) {
    console.error(valuesError.message);
    return <div>Error! {valuesError.message}</div>;
  }

  const allData = allDataFn(metaData);
  // const chartData = mergeSeries(dataSeries.dataSeries);
  return (
    <TrendGraphHighcharts
      // nodes={nodes}
      allData={allData}
      metaData={metaData}
      // chartData={chartData}
      dataSeries={dataSeries ? dataSeries.dataSeries : undefined}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
    />
  );
}

export default TrendGraphContainer;
